import React from "react";
import RichText from "./richtext";
import ImageGallery from "./image-gallery";

const Slice = ({ slice_type, primary, items }) => (
  <>
    {slice_type === "richtext" && <RichText html={primary.rich_text.html} />}
    {slice_type === "image" && (
      <img src={primary.image.url} alt={primary.image.alt} className="my-4" />
    )}
    {slice_type === "50_50" && <FiftyFifty primary={primary} />}
    {slice_type === "image_gallery" && <ImageGallery items={items} />}
  </>
);

const FiftyFifty = ({ primary }) => (
  <div className="flex flex-col md:flex-row">
    <div className="md:w-1/2 md:pr-4">
      <RichText html={primary.section_one.html} />
    </div>
    <div className="md:w-1/2 md:pl-4">
      <RichText html={primary.section_two.html} />
    </div>
  </div>
);

export default Slice;
